import { ASSETS } from "@/lib/constants";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-black text-[#F5F3EF] mt-24 border-t border-[#D4AF37]/20">
      <div className="tribal-stripe h-1.5 w-full" />
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={ASSETS.seal} alt="Seal" className="h-14 w-14 object-contain" />
            <div className="font-serif-display text-xl">The Black American Government</div>
          </div>
          <p className="text-sm text-white/60 leading-relaxed max-w-xs">
            Indigenous Black American Tribal Nation. A perpetual national community united by ancestry,
            common history, and shared institutions.
          </p>
        </div>
        <div>
          <div className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-semibold mb-4">Navigate</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/" className="hover:text-[#D4AF37]">Home</Link></li>
            <li><Link to="/the-nation" className="hover:text-[#D4AF37]">The Nation</Link></li>
            <li><Link to="/census" className="hover:text-[#D4AF37]">The Black Census</Link></li>
            <li><Link to="/legal-standing" className="hover:text-[#D4AF37]">Our Legal Standing</Link></li>
            <li><Link to="/cerd-obligations" className="hover:text-[#D4AF37]">CERD Obligations</Link></li>
            <li><Link to="/register" className="hover:text-[#D4AF37]">Become a Member</Link></li>
            <li><Link to="/committees" className="hover:text-[#D4AF37]">Committees & Programs</Link></li>
            <li><Link to="/login" className="hover:text-[#D4AF37]">Member Login</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-semibold mb-4">Our Creed</div>
          <p className="font-serif-display text-2xl leading-snug">
            Unity &middot; Self-Determination &middot; Service
          </p>
          <p className="text-sm text-white/50 mt-3 italic">
            For Our People. By Our People. Through Our Oneness.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        &copy; {new Date().getFullYear()} Indigenous Black American Tribal Nation d/b/a The Black American Government. All rights reserved.
      </div>
    </footer>
  );
}
